const staticData = {
    "items":[
        {
            id: '5',
            url: '/reports/dashboardStaticCount/v1/',
            display_text : "Count of Unique SKUs",
            report_type: "UniqueSKU",
            data_count:0,
			data_unit:'',
			show: true
        },{
            id: '6',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Total Stock in Inventory (Pcs)",
            report_type: "SKUInventoryQty",
            data_count:0,
			data_unit:'',
			show: true
        },{
            id: '7',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Stock Value by MRP",
            report_type: "ValueInventory",
            data_count:0,
			data_unit:"&#8377",
			show: true
        },{
            id: '8',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Current Available Space",
            report_type: "VolumeAvailable",
            data_count:0,
			data_unit:"m<sup>3</sup>",
			show: true
        },{
            id: '9',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Total Free Bins",
            report_type: "AvailableBins",
            data_count:0,
			data_unit:"",
			show: true
        },{
            id: '10',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Picking Productivity",
            report_type: "PickingProductivity",
            data_count:0,
			data_unit:"",
			show: true
        },{
            id: '11',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Putaway Productivity",
            report_type: "PutawayProductivity",
            data_count:0,
			data_unit:"",
			show: true
   }
    ]
}

export default staticData;